<template>
    <div class="flex relative my-auto container mx-auto">

      <div class="subsection-big-circle bg-black rounded-full mx-auto">
        <h1 class="deep-info-sub-heading text-white mx-auto pt-20 text-2xl font-bold">EMOTIONAL <br>BONDING</h1>
        <p class="text-teal mt-8 text-4xl font-bold leading-tight">INCREASING <br>LOYALTY TO THE <br>EXISTING <br>APPS</p>
      </div>

      <NextArrow next="sub-offer-two"/>

    </div>
</template>

<script>
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "OfferSubOne",
  components:{
    NextArrow
  }
}
</script>
